import Api from './baseApi';

export default {
  getAtolyeler: () => Api.get('/api/Atolye'),
  createAtolye: (payload) => Api.post('/api/Atolye', payload),
  updateAtolye: (id, payload) => Api.put(`/api/Atolye/${id}`, payload),
  deleteAtolye: (id) => Api.delete(`/api/Atolye/${id}`),
  canView: () => Api.get('/api/Atolye/can-view'),
  getBalances: () => Api.get('/api/Atolye/balances'),
  getMovements: (atolyeId, startDate, endDate, barcode) => Api.get('/api/Atolye/movements', { params: { atolyeId, startDate, endDate, barcode } }),
  sendGold: (payload) => Api.post('/api/Atolye/send-gold', payload),
  receiveProduct: (payload) => Api.post('/api/Atolye/receive-product', payload),
};
